import { createContext } from "react";
import useAgentPersonnelSummaries from "../hooks/data/useAgentPersonnelSummaries";

export interface IAgentPersonnelSummaries extends ReturnType<typeof useAgentPersonnelSummaries> {

};

const AgentPersonnelSummariesContext = createContext<IAgentPersonnelSummaries>({
    data: undefined,
    error: undefined,
    loading: true,
    validating: true,
    mutate: async () => { return undefined },
    refresh: async () => { return undefined },
});

export default AgentPersonnelSummariesContext